import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useForm } from "antd/lib/form/Form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { Button, Checkbox, Col, DatePicker, Form, Row } from "antd";
import { BsFillCalendar2WeekFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { IoIosText } from "react-icons/io";
import { db, auth } from "../../../../../../firebase";
import {
  collection,
  doc,
  query,
  where,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";

import SubHeading from "../../../../../../components/common/SubHeading";
import WarningMessage from "../../../../../../components/common/WarningMessage";
import {
  SelectMoveInTenantInfo,
} from "../../../../../../store/moveInTenantSlice";

import "./FinishMoveIn.css";

const textMessage = (
  <>
    Please verify that tenants have both{" "}
    <span className="onclick-text">
      a unique phone number and a unique email address
    </span>{" "}
    on file in order to send the online portal activation text.
  </>
);
const emailMessage = (
  <>
    There are no email addresses on file. Please{" "}
    <span className="onclick-text">collect email addresses</span> in order to
    send online portal activation emails.
  </>
);

function FinishMoveIn({ current, setCurrent }) {
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);
  const moveInTenantInfo = useSelector(SelectMoveInTenantInfo);
  const [form] = useForm();
  const navigate = useNavigate();

  const prev = () => {
    setCurrent(current - 1);
  };

  const handleFormSubmit = () => {
    form
      .validateFields()
      .then(() => {
        // Handle form submission with valid values
        const formData = form.getFieldsValue();
        Object.keys(formData).forEach((field) => {
          if (formData[field] === undefined) {
            formData[field] = "";
          }
        });
        try {
          const companiesRef = collection(db, "companies");
          const companyDocRef = doc(companiesRef, companyName);
          const leaseRef = doc(companyDocRef, "leases", moveInTenantInfo.leaseId);
    
          updateDoc(leaseRef, {
            "leaseDates.leaseSignedDate": formData.leaseSignedDate
            ? formData.leaseSignedDate.format("YYYY-MM-DD")
            : "",
          });
        } catch (err) {
          console.error(err);
          alert(err.message);
        }

        try {
          const tenantRef = doc(db, "companies", companyName, "tenants", moveInTenantInfo.tenantId);
    
          updateDoc(tenantRef, {
           "emailRentReminders": formData.emailRentReminders,
           "leaseInformation.signedDate": formData.leaseSignedDate
           ? formData.leaseSignedDate.format("YYYY-MM-DD")
           : "",
           "leaseId": moveInTenantInfo.leaseId,
          });
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
        navigate("/");
      })
      .catch((errorInfo) => {
        // Handle form submission with validation errors
        console.log("Validation Errors:", errorInfo.errorFields);
      });
  };
  const onFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };
  console.log("Move In Tenant", moveInTenantInfo);
  return (
    <div className="finish-move-in">
      <SubHeading subHeading="Finish Move In" />
      <Form
        layout="vertical"
        onFinish={handleFormSubmit}
        onFinishFailed={onFinishFailed}
        form={form}
      >
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <WarningMessage message="A screening report is not detected for this tenant." />
          </Col>
          <Col span={24}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <p>Move In Summary</p>
              </Col>
              <Col span={24}>
                <Form.Item label="Lease Signed Date" name="leaseSignedDate">
                  <DatePicker />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[32, 0]}>
              <Col span={3}>
                <strong>Tenants</strong>
              </Col>
              <Col span={13}>
                <strong>Unit</strong>
              </Col>
              <Col span={8}>
                <strong>Move In date</strong>
              </Col>
            </Row>
            <Row gutter={[32, 0]}>
              <Col span={3}>
                <span>
                  {moveInTenantInfo.profileInfo?.firstName}{" "}
                  {moveInTenantInfo.profileInfo?.lastName}
                </span>
              </Col>
              <Col span={13}>
                <span>{moveInTenantInfo.propertyUnit?.value}</span>
              </Col>
              <Col span={8}>
                <span>
                  {moveInTenantInfo.leaseDetails.leaseDates?.moveInDate}
                </span>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <p>Tenant Payment Schedule</p>
              </Col>
              <Col span={24} className="payment-schedule">
                <Row className="items-center">
                  <Col span={8}>
                    <h3>
                      $
                      {
                        moveInTenantInfo.leaseDetails.tenantPaymentSchedule
                          ?.dueOnceMoveInCompleted
                      }
                    </h3>
                    <span>Due Once Move In Completed</span>
                  </Col>
                  <Col span={8} className="inline-border">
                    <h3>
                      $
                      {
                        moveInTenantInfo.leaseDetails.tenantPaymentSchedule
                          ?.dueOnMoveInDate
                      }
                    </h3>
                    <span>
                      Due On{" "}
                      {moveInTenantInfo.leaseDetails.leaseDates?.moveInDate}
                    </span>
                  </Col>
                  <Col span={8}>
                    <h3>
                      $
                      {
                        moveInTenantInfo.leaseDetails.tenantPaymentSchedule
                          ?.dueMonthlyThereafter
                      }
                    </h3>
                    <span>Due Monthly Thereafter</span>
                  </Col>
                </Row>
              </Col>
              <Col span={24} className="rent-reminder">
                <p className="icon-text-container">
                  <BsFillCalendar2WeekFill size={18} />
                  <span>Rent Reminders</span>
                </p>
                <Form.Item name="emailRentReminders" valuePropName="cheched">
                  <Checkbox>
                    Automatically email monthly rent reminders
                  </Checkbox>
                </Form.Item>
                <p className="silver-text">
                  Note: In order for a tenant to receive rent reminders, he/she
                  must have a{" "}
                  <span className="onclick-text">unique email address</span> on
                  file.
                </p>
              </Col>
              <Col span={24}>
                <p>Lease Fee Bill</p>
              </Col>
              <Col span={24} className="lease-fee-bill">
                <h3>$200.00</h3>
                <span>
                  Lease fee bill, dated 03/02/2023, will be created when move in
                  is completed
                </span>
              </Col>
            </Row>
          </Col>
          <Col span={24} className="bordered-row-container">
            <Row className="bordered-row-container">
              <Col span={24}>
                <p>Move In Survey</p>
              </Col>
              <Col span={24} className="gap">
                <p className="icon-text-container">
                  <MdEmail size={18} />
                  <span>Email Survey</span>
                </p>
                <WarningMessage message="There are no email addresses on file." />
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <p>Online Portal Activation</p>
              </Col>
              <Col span={24} className="bordered-row-container gap">
                <p className="icon-text-container">
                  <IoIosText size={18} />
                  <span>Text Activation</span>
                </p>
                <WarningMessage message={textMessage} />
              </Col>
              <Col span={24} className="bordered-row-container gap">
                <p className="icon-text-container">
                  <MdEmail size={18} />
                  <span>Email Activation</span>
                </p>
                <WarningMessage message={emailMessage} />
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <WarningMessage message="You are attempting to post charges to a future month." />
          </Col>
          <Col span={24}>
            <Row gutter={[8, 0]} justify="end">
              <Col>
                <Button type="primary" htmlType="submit">
                  Done
                </Button>
              </Col>
              <Col>
                <Button onClick={() => prev()}>Previous</Button>
              </Col>
              <Col>
                <Button type="link" onClick={() => navigate("/")}>
                  Cancel Move In
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default FinishMoveIn;
